import NotificationTransportType from 'linced-app/enums/notification-transport-type';

export function isPushNotification(transportType) {
  return NotificationTransportType.pushTransports.has(transportType);
}

export function isEmailNotification(transportType) {
  return NotificationTransportType.emailTransports.has(transportType);
}

export function getNotificationTypeLabel(transportName) {
  return NotificationTransportType.values.find(
    (notificationTransport) => notificationTransport.value === transportName,
  ).label;
}
